<button
  [ngClass]="{ button: true, 'button-outlined': type() === 'outlined' }"
  [disabled]="disabled()"
  (click)="onClick.emit($event)">
  {{ label() }}
</button>
